var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSecondStepJourneyOld = function SvgSecondStepJourneyOld(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M6.27 2.867a3.204 3.204 0 0 1 3.198 3.198v2.027h.107a1.686 1.686 0 0 0 1.68-1.686V2.76a1.68 1.68 0 0 0-1.68-1.68H5.93a1.686 1.686 0 0 0-1.686 1.68v.107zm-2.37.344V2.76A2.03 2.03 0 0 1 5.928.736h3.646A2.024 2.024 0 0 1 11.6 2.76v3.646a2.03 2.03 0 0 1-2.024 2.03h-.45v-2.37A2.86 2.86 0 0 0 6.27 3.21z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M6.562 6.562a.41.41 0 0 0-.583 0L4.236 8.245l-.682-.67a.413.413 0 0 0-.589.55l.968.995a.42.42 0 0 0 .583 0l2.035-1.964a.41.41 0 0 0 .011-.594M4.756 9.366a.76.76 0 0 1-1.063 0l-.003-.003-1-1.028-.02-.036a.756.756 0 0 1 1.078-1.008l.025.017.465.457 1.5-1.448a.756.756 0 1 1 1.05 1.089zM2.624 4.12A2.03 2.03 0 0 0 .6 6.15v3.646a2.024 2.024 0 0 0 2.024 2.024h3.647A2.03 2.03 0 0 0 8.3 9.796V6.15a2.03 2.03 0 0 0-2.03-2.03zm3.647.344H2.625A1.686 1.686 0 0 0 .944 6.15v3.646a1.68 1.68 0 0 0 1.68 1.68h3.647a1.686 1.686 0 0 0 1.686-1.68V6.15A1.686 1.686 0 0 0 6.27 4.464",
    clipRule: "evenodd"
  })));
};
export default SvgSecondStepJourneyOld;